import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  UserPendingProductReview,
  UserProductReview,
} from '../interfaces/user-product-review.interface';

const apiUrl = environment.apiUrl + 'user/product_review';

@Injectable({
  providedIn: 'root',
})
export class
UserReviewProductService {
  constructor(
    private http: HttpClient,
    private datePipe: DatePipe,
    private messageService: MessageService
  ) {}

  getPendingReview(itemPerPage: number, curretPage = 1) {
    return this.http
      .post(apiUrl + '/search', {
        item_per_page: itemPerPage,
        current_page: curretPage,
        reviewed: false,
      })
      .pipe(
        map((res: any) => {
          let reviews: UserPendingProductReview[] =
            res['data']['product_reviews'];
          reviews.forEach((rv: any) => {
            if (rv.order_date)
              rv.formatted_order_date = this.datePipe.transform(
                rv.order_date,
                'dd MMM yyyy, HH:mm'
              );
          });
          return { totalItems: res['data']['total_items'], reviews: reviews };
        })
      );
  }

  getReviewHistory(itemPerPage: number, curretPage = 1) {
    return this.http
      .post(apiUrl + '/search', {
        item_per_page: itemPerPage,
        current_page: curretPage,
        reviewed: true,
      })
      .pipe(
        map((res: any) => {
          let reviews: UserProductReview[] = res['data']['product_reviews'];
          reviews.forEach((rv: any) => {
            if (rv.order_date)
              rv.formatted_order_date = this.datePipe.transform(
                rv.order_date,
                'dd MMM yyyy, HH:mm'
              );
          });
          return { totalItems: res['data']['total_items'], reviews: reviews };
        })
      );
  }

  addProductreview(formData: any) {
    return this.http.post(apiUrl, formData).pipe(
      map((res) => {
        this.handleSuccess('Berhasil memberikan ulasan produk');
        return res;
      })
    );
  }

  private handleSuccess(message: string) {
    this.messageService.clear();
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: message,
    });
  }
}
